import { render, staticRenderFns } from "./ConsentDocumentManagement.vue?vue&type=template&id=51305c72"
import script from "./ConsentDocumentManagement.vue?vue&type=script&lang=js"
export * from "./ConsentDocumentManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports